import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, UserRound, X } from "lucide-react";
import logoMark from "../assets/releaf_mark.png";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Memberships", id: "memberships" },
  { label: "Cannabis Cards", id: "cannabis" },
  { label: "About", id: "about" },
  { label: "Pricing", id: "pricing" },
  { label: "Visit Us", id: "visit" },
];

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 72;
  window.scrollTo({ top, behavior: "smooth" });
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(id), 350);
    } else {
      scrollToSection(id);
    }
  };

  return (
    <header data-testid="main-navbar" className="sticky top-0 z-50 border-b border-linen bg-ivory">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={logoMark} alt="Releaf monogram" className="h-10 w-auto" />
          <span className="leading-none">
            <span className="block font-serif text-2xl font-medium text-forest">Releaf</span>
            <span className="block text-[9px] font-semibold uppercase tracking-[0.2em] text-moss">
              Wellness &amp; Aesthetics
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-forest/80 transition-colors duration-300 hover:text-forest"
            >
              {l.label}
            </button>
          ))}
          <Link to="/gift" data-testid="nav-gift-link" className="text-sm font-medium text-forest/80 transition-colors duration-300 hover:text-forest">
            Gift Cards
          </Link>
          <Link to="/portal" data-testid="nav-portal-link" className="flex items-center gap-1.5 text-sm font-medium text-forest/80 transition-colors duration-300 hover:text-forest">
            <UserRound size={15} /> Patient Portal
          </Link>
          <Link
            to="/book"
            data-testid="nav-book-button"
            className="rounded-md bg-forest px-5 py-2.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-forest-dark"
          >
            Book Now
          </Link>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-linen text-forest lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <nav className="border-b border-linen bg-ivory lg:hidden">
          <div className="flex flex-col gap-1 px-6 py-5">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="py-2.5 text-left text-base font-medium text-forest"
              >
                {l.label}
              </button>
            ))}
            <Link to="/gift" data-testid="nav-mobile-gift-link" onClick={() => setOpen(false)} className="py-2.5 text-left text-base font-medium text-forest">Gift Cards</Link>
            <Link to="/portal" data-testid="nav-mobile-portal-link" onClick={() => setOpen(false)} className="py-2.5 text-left text-base font-medium text-forest">Patient Portal</Link>
            <Link
              to="/book"
              data-testid="nav-mobile-book-button"
              onClick={() => setOpen(false)}
              className="mt-3 rounded-md bg-forest px-5 py-3 text-center text-sm font-semibold text-ivory"
            >
              Book Now
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
